/**
 * 生成並管理設備 ID (MD5)
 * 設備 ID 會存儲在 localStorage 中，確保同一設備每次登入使用相同的 ID
 */

const STORAGE_KEY = 'device_id';

/**
 * MD5 哈希函數實現
 * 這是一個純 JavaScript 的 MD5 實現
 */
function md5Hash(text: string): string {
  // MD5 實現（簡化版本，基於標準 MD5 算法）
  function md5cycle(
    x: [number, number, number, number],
    k: [
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
    ]
  ): void {
    let a = x[0];
    let b = x[1];
    let c = x[2];
    let d = x[3];

    a = ff(a, b, c, d, k[0], 7, -680876936);
    d = ff(d, a, b, c, k[1], 12, -389564586);
    c = ff(c, d, a, b, k[2], 17, 606105819);
    b = ff(b, c, d, a, k[3], 22, -1044525330);
    a = ff(a, b, c, d, k[4], 7, -176418897);
    d = ff(d, a, b, c, k[5], 12, 1200080426);
    c = ff(c, d, a, b, k[6], 17, -1473231341);
    b = ff(b, c, d, a, k[7], 22, -45705983);
    a = ff(a, b, c, d, k[8], 7, 1770035416);
    d = ff(d, a, b, c, k[9], 12, -1958414417);
    c = ff(c, d, a, b, k[10], 17, -42063);
    b = ff(b, c, d, a, k[11], 22, -1990404162);
    a = ff(a, b, c, d, k[12], 7, 1804603682);
    d = ff(d, a, b, c, k[13], 12, -40341101);
    c = ff(c, d, a, b, k[14], 17, -1502002290);
    b = ff(b, c, d, a, k[15], 22, 1236535329);

    a = gg(a, b, c, d, k[1], 5, -165796510);
    d = gg(d, a, b, c, k[6], 9, -1069501632);
    c = gg(c, d, a, b, k[11], 14, 643717713);
    b = gg(b, c, d, a, k[0], 20, -373897302);
    a = gg(a, b, c, d, k[5], 5, -701558691);
    d = gg(d, a, b, c, k[10], 9, 38016083);
    c = gg(c, d, a, b, k[15], 14, -660478335);
    b = gg(b, c, d, a, k[4], 20, -405537848);
    a = gg(a, b, c, d, k[9], 5, 568446438);
    d = gg(d, a, b, c, k[14], 9, -1019803690);
    c = gg(c, d, a, b, k[3], 14, -187363961);
    b = gg(b, c, d, a, k[8], 20, 1163531501);
    a = gg(a, b, c, d, k[13], 5, -1444681467);
    d = gg(d, a, b, c, k[2], 9, -51403784);
    c = gg(c, d, a, b, k[7], 14, 1735328473);
    b = gg(b, c, d, a, k[12], 20, -1926607734);

    a = hh(a, b, c, d, k[5], 4, -378558);
    d = hh(d, a, b, c, k[8], 11, -2022574463);
    c = hh(c, d, a, b, k[11], 16, 1839030562);
    b = hh(b, c, d, a, k[14], 23, -35309556);
    a = hh(a, b, c, d, k[1], 4, -1530992060);
    d = hh(d, a, b, c, k[4], 11, 1272893353);
    c = hh(c, d, a, b, k[7], 16, -155497632);
    b = hh(b, c, d, a, k[10], 23, -1094730640);
    a = hh(a, b, c, d, k[13], 4, 681279174);
    d = hh(d, a, b, c, k[0], 11, -358537222);
    c = hh(c, d, a, b, k[3], 16, -722521979);
    b = hh(b, c, d, a, k[6], 23, 76029189);
    a = hh(a, b, c, d, k[9], 4, -640364487);
    d = hh(d, a, b, c, k[12], 11, -421815835);
    c = hh(c, d, a, b, k[15], 16, 530742520);
    b = hh(b, c, d, a, k[2], 23, -995338651);

    a = ii(a, b, c, d, k[0], 6, -198630844);
    d = ii(d, a, b, c, k[7], 10, 1126891415);
    c = ii(c, d, a, b, k[14], 15, -1416354905);
    b = ii(b, c, d, a, k[5], 21, -57434055);
    a = ii(a, b, c, d, k[12], 6, 1700485571);
    d = ii(d, a, b, c, k[3], 10, -1894986606);
    c = ii(c, d, a, b, k[10], 15, -1051523);
    b = ii(b, c, d, a, k[1], 21, -2054922799);
    a = ii(a, b, c, d, k[8], 6, 1873313359);
    d = ii(d, a, b, c, k[15], 10, -30611744);
    c = ii(c, d, a, b, k[6], 15, -1560198380);
    b = ii(b, c, d, a, k[13], 21, 1309151649);
    a = ii(a, b, c, d, k[4], 6, -145523070);
    d = ii(d, a, b, c, k[11], 10, -1120210379);
    c = ii(c, d, a, b, k[2], 15, 718787259);
    b = ii(b, c, d, a, k[9], 21, -343485551);

    x[0] = add32(a, x[0]);
    x[1] = add32(b, x[1]);
    x[2] = add32(c, x[2]);
    x[3] = add32(d, x[3]);
  }

  function cmn(q: number, aParam: number, b: number, x: number, s: number, t: number): number {
    const a = add32(add32(aParam, q), add32(x, t));
    return add32((a << s) | (a >>> (32 - s)), b);
  }

  function ff(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
    return cmn((b & c) | (~b & d), a, b, x, s, t);
  }

  function gg(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
    return cmn((b & d) | (c & ~d), a, b, x, s, t);
  }

  function hh(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
    return cmn(b ^ c ^ d, a, b, x, s, t);
  }

  function ii(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  function add32(a: number, b: number): number {
    return (a + b) & 0xffffffff;
  }

  function rhex(n: number): string {
    let s = '';
    const hexChr = '0123456789abcdef';
    for (let j = 0; j < 4; j++) {
      s += hexChr.charAt((n >> (j * 8 + 4)) & 0x0f) + hexChr.charAt((n >> (j * 8)) & 0x0f);
    }
    return s;
  }

  // 將字符串轉換為字節數組
  const utf8Encode = (str: string): number[] => {
    const utf8: number[] = [];
    for (let i = 0; i < str.length; i++) {
      let charcode = str.charCodeAt(i);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
      } else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(
          0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f)
        );
      } else {
        i++;
        charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
        utf8.push(
          0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f)
        );
      }
    }
    return utf8;
  };

  const msg = utf8Encode(text);
  const msgLen = msg.length;
  const state: [number, number, number, number] = [1732584193, -271733879, -1732584194, 271733878];
  let i: number;

  // 填充
  msg[msgLen] = 0x80;
  for (i = msgLen + 1; i % 64 !== 56; i++) {
    msg[i] = 0;
  }
  msg[i++] = (msgLen * 8) & 0xff;
  msg[i++] = ((msgLen * 8) >>> 8) & 0xff;
  msg[i++] = ((msgLen * 8) >>> 16) & 0xff;
  msg[i++] = ((msgLen * 8) >>> 24) & 0xff;
  msg[i++] = 0;
  msg[i++] = 0;
  msg[i++] = 0;
  msg[i++] = 0;

  // 處理每個 512 位塊
  for (i = 0; i < msg.length; i += 64) {
    const w: [
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
      number,
    ] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (let j = 0; j < 16; j++) {
      const idx = i + j * 4;
      w[j] =
        (msg[idx] ?? 0) |
        ((msg[idx + 1] ?? 0) << 8) |
        ((msg[idx + 2] ?? 0) << 16) |
        ((msg[idx + 3] ?? 0) << 24);
    }
    md5cycle(state, w);
  }

  return rhex(state[0]) + rhex(state[1]) + rhex(state[2]) + rhex(state[3]);
}

/**
 * 生成或獲取設備 ID
 * 如果 localStorage 中已存在，則返回現有的 ID
 * 否則生成新的 ID 並存儲
 */
export const useDeviceId = () => {
  const getOrCreateDeviceId = (): string => {
    if (!import.meta.client) {
      // SSR 環境返回空字符串
      return '';
    }

    try {
      // 嘗試從 localStorage 獲取現有的 device_id
      const storedDeviceId = localStorage.getItem(STORAGE_KEY);
      if (storedDeviceId) {
        return storedDeviceId;
      }

      // 生成新的設備 ID
      // 使用多個因素組合生成唯一標識符
      const factors: string[] = [];

      // 1. 生成 UUID（如果支持）
      if (crypto.randomUUID) {
        factors.push(crypto.randomUUID());
      } else {
        // 降級方案：使用時間戳和隨機數
        factors.push(`${Date.now()}-${Math.random()}`);
      }

      // 2. 添加用戶代理信息（不包含完整 UA，只取部分特徵）
      if (navigator.userAgent) {
        factors.push(navigator.userAgent);
      }

      // 3. 添加語言設置
      if (navigator.language) {
        factors.push(navigator.language);
      }

      // 4. 添加時區
      factors.push(Intl.DateTimeFormat().resolvedOptions().timeZone || '');

      // 組合所有因素
      const deviceIdentifier = factors.join('|');

      // 計算 MD5
      const deviceId = md5Hash(deviceIdentifier);

      // 存儲到 localStorage
      localStorage.setItem(STORAGE_KEY, deviceId);

      return deviceId;
    } catch (error) {
      console.warn('Failed to get or create device ID:', error);
      // 降級方案：返回一個基於時間戳的簡單哈希
      const fallbackId = md5Hash(`${Date.now()}-${Math.random()}`);
      try {
        localStorage.setItem(STORAGE_KEY, fallbackId);
      } catch {
        // 如果 localStorage 不可用，忽略
      }
      return fallbackId;
    }
  };

  return {
    getOrCreateDeviceId,
  };
};
